module.exports = __webpack_public_path__ + "img/Download Center.72458c58.svg";